__webpack_require__.p = "/bizx-health/central-medical/";